"use strict";
import Swiper from "swiper";
import {Autoplay, Navigation, Pagination} from "swiper/modules"
import {Modal} from 'bootstrap';
import SVGInject from '@iconfu/svg-inject';
import {Fancybox} from "@fancyapps/ui";
import ma5menu from "./ma5-menu";
import Cookies from 'js-cookie'


var MainScripts = function () {
    jQuery.fn.exists = function () {
        return this !== null && this !== undefined;
    }


    var swiperUse = function () {
        Swiper.use([Navigation, Pagination, Autoplay]);
    }


    var homeSwipers = function () {

        const home_slider = new Swiper('.home-slider', {
            loop: false,
            speed: 1000,
            grabCursor: true,
            watchSlidesProgress: true,
            mousewheelControl: true,
            keyboardControl: true,
            navigation: {
                nextEl: '.home-slider .buttons .swiper-next',
                prevEl: '.home-slider .buttons .swiper-prev',
            },
            on: {
                init: function () {
                    updateSwiperNumber(this.realIndex + 1);
                },
                slideChange: function (swiper) {
                    updateSwiperNumber(this.realIndex + 1);
                }
            }
        });

        function updateSwiperNumber(index) {
            const swiperNumberElement = document.querySelector('.home-slider .swiper-number');
            if (swiperNumberElement) {
                swiperNumberElement.textContent = (index < 10 ? '0' + index : index);
            }
        }

        new Swiper('.home-about .image .swiper', {
            slidesPerView: 1,
            spaceBetween: 30,
            slidesPerGroup: 1,
            speed: 1000,
            pagination: {
                el: '.home-about .swiper-pagination',
                clickable: true,
            },
        });

        new Swiper('.home-references .swiper', {
            slidesPerView: 10,
            spaceBetween: 75,
            autoplay: {
                delay: 3000,
            },
            speed: 1000,
            breakpoints: {
                0: {
                    slidesPerView: 2,
                    spaceBetween: 40,
                },
                768: {
                    slidesPerView: 4,
                    spaceBetween: 40,
                },
                1200: {
                    slidesPerView: 6,
                    spaceBetween: 40,
                },
                1500: {
                    slidesPerView: 8,
                    spaceBetween: 50,
                },
                1740: {
                    slidesPerView: 10,
                    spaceBetween: 75,
                }
            }
        });
    }

    const scrollToAlert = () => {
        setTimeout(function () {
            let alert = $('.alert');
            if (alert.exists()) {
                let offset = alert.offset();
                let top = offset.top;
                window.scrollTo({
                    top: top,
                    behavior: 'smooth'
                });
            }
        }, 300)
    }

    var formPOST = function () {
        let forms = document.querySelectorAll('form[method="post"]:not(.no-ajax)');
        if (forms.length > 0) {
            forms.forEach(function (el) {
                el.addEventListener('submit', function (e) {
                    let form = this;
                    form.querySelector('button[type="submit"]').setAttribute('disabled', 'disabled');
                })
            });
        }
    }


    var getKvKK = function () {
        if (document.querySelectorAll('.kvkk')) {
            document.querySelectorAll('.kvkk').forEach(function (el) {
                el.addEventListener('click', function () {
                    fetch(window.siteurl + 'kvkk', {
                        method: 'POST',
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            'Data-Type': 'application/json'
                        }
                    }).then((response) => response.json())
                        .then((data) => {
                            const myModal = CreateModal(data);
                            myModal.show();
                        }).catch((error) => {
                        console.error('Error:', error);
                    });
                });
            })
        }
    }


    function CreateModal(dt) {
        let id = '#kvkk-' + dt.id;
        let element = document.getElementById(id);
        if (typeof (element) != 'undefined' && element != null) {
            $(id).find("#ModalLabel").text(dt.title);
            $(id).find("#ModalContent").html(dt.description);
        } else {
            $('body').append('<div class="modal fade" id="' + id + '" tabindex="-1">\n' +
                '  <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-xl kvkk-modal">\n' +
                '    <div class="modal-content">\n' +
                '      <div class="modal-header">\n' +
                '        <h5 class="modal-title" id="ModalLabel">' + dt.title + '</h5>\n' +
                '        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Kapat"></button>\n' +
                '      </div>\n' +
                '      <div class="modal-body" id="ModalContent"><div class="page-content">\n' + dt.description +
                '      </div>\n' +
                '      </div>\n' +
                '      <div class="modal-footer">\n' +
                '        <button type="button" class="btn btn-secondary text-white" data-bs-dismiss="modal">' + window.lang.closeButton + '</button>\n' +
                '      </div>\n' +
                '    </div>\n' +
                '  </div>\n' +
                '</div>');
            element = document.getElementById(id);
        }
        return new Modal(element, {});
    }

    var contacts = function () {

        $('.whatsapp_bubble').on('click', function () {
            if ($('.whatsapp_pp').hasClass('active')) {
                $('.whatsapp_pp').removeClass('active')
            } else {
                $('.whatsapp_pp').addClass('active')
            }
        });

        setTimeout(function () {
            $('.whatsapp_bubble').trigger('click');
        }, 30000);


        $('.whatsapp_pp .close_pp').on('click', function () {
            $('.whatsapp_pp').removeClass('active')
        });
    }

    const mobileMenu = () => {
        ma5menu({
            menu: 'header .menu-list',
            activeClass: 'active',
            footer: '#ma5menu-tools',
            position: 'left',
            closeOnBodyClick: true
        });


        if (window.innerWidth < 992) {
            $('.ma5menu__panel ul li svg,.ma5menu__panel ul li img').remove();
            $('.ma5menu__panel ul li a').each(function () {
                const $this = $(this);
                if ($this.html().replace(/\s|&nbsp;/g, '').length === 0)
                    $this.remove();
            });
            $('.menu-list li a').remove();
        }

        let ma5List = document.querySelectorAll('.ma5menu__panel ul li');
        ma5List.forEach((el) => {
            if (el.querySelector('svg')) {
                let index = Array.prototype.indexOf.call(ma5List, el);
                el.querySelector('svg').remove();
                el.querySelector('a').innerHTML = el.querySelector('a').getAttribute('title');
            }
        })
    }

    var observer = function () {

        const observer = new IntersectionObserver(entries => {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    let lazyImage = entry.target;
                    lazyImage.classList.add('loaded');
                    lazyImage.src = lazyImage.dataset.src;
                    lazyImage.classList.remove("lazy");
                    observer.unobserve(lazyImage);

                    if (lazyImage.classList.contains('svg-inject'))
                        SVGInject(lazyImage);
                }
            });
        }, {
            rootMargin: "0px"
        });

        $(function () {
            let srcItems = document.querySelectorAll('[data-src]');
            srcItems.forEach(box => {
                observer.observe(box);
            });
        });

        const lazyBackgroundImages = document.querySelectorAll('.lazy-bg');


        const imageObserver = new IntersectionObserver((entries, imageObserver) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    showImageBackground(entry.target);
                    imageObserver.unobserve(entry.target);
                }
            });
        }, {
            threshold: 0,
            rootMargin: "0px 0px 50px 0px"
        });

        lazyBackgroundImages.forEach(image => {
            imageObserver.observe(image);
        });

        function showImageBackground(node) {
            node.classList.remove('lazy-bg');
        }
    }

    var onload = function () {

        if (screen.width <= 768 && !Cookies.get('popup')) {
            if ($('#callingPopupModal').length > 0) {
                let PopupModal = new Modal(document.getElementById('callingPopupModal'))
                setTimeout(function () {
                    PopupModal.show()
                }, 10000);

                var pp = document.getElementById('callingPopupModal')
                pp.addEventListener('hidden.bs.modal', function () {
                    if ($('#neverShowAgain').is(':checked')) {
                        var inFiveMinutes = new Date(new Date().getTime() + 5 * 60 * 1000)
                        Cookies.set('popup', 'true', {expires: inFiveMinutes});
                    }
                })
            }
        }

        // $('.select-2').select2({
        //     theme: 'bootstrap-5',
        // });

        SVGInject(document.querySelectorAll('img.svg-inject'));
    }


    return {
        init: function () {
            Fancybox.bind("[data-fancybox]", {});
            observer();
            swiperUse();
            homeSwipers();
            getKvKK();
            scrollToAlert();
            formPOST();
            mobileMenu();
            contacts();
            onload();
        },
    };
}();

// On document ready
jQuery(document).ready(function () {
    MainScripts.init();
});